export const comicCategories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'fantasy', name: '玄幻奇幻', icon: 'ri-magic-line' },
  { slug: 'urban', name: '都市异能', icon: 'ri-building-line' },
  { slug: 'cultivation', name: '修仙武侠', icon: 'ri-sword-line' },
  { slug: 'scifi', name: '科幻未来', icon: 'ri-rocket-line' },
  { slug: 'history', name: '历史穿越', icon: 'ri-history-line' },
  { slug: 'romance', name: '恋爱剧情', icon: 'ri-heart-line' },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line' },
  { slug: 'suspense', name: '悬疑推理', icon: 'ri-search-eye-line' },
  { slug: 'horror', name: '惊悚灵异', icon: 'ri-ghost-line' },
];

export const comics = [
  {
    id: 1,
    title: '全职法师',
    author: '乱',
    artist: '阅文漫画',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20art%20featuring%20a%20powerful%20young%20male%20mage%20in%20a%20dark%20blue%20robe%20surrounded%20by%20glowing%20magical%20flames%20and%20lightning%20effects%2C%20dramatic%20composition%2C%20vibrant%20anime%20style%20illustration%20with%20dynamic%20action%20pose%2C%20clean%20white%20background%20with%20soft%20gradient&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    rating: 9.6,
    popularity: 9854321,
    status: '连载中',
    description: '一觉醒来，世界巨变。主角莫凡穿越到魔法世界，在这里，魔法已经成为一门科学，而他就是那个拥有全系魔法天赋的绝世天才！在这个充满危机与挑战的世界里，他凭借着自己的天赋与努力，一步步踏上魔法巅峰。',
    chapters: 486,
    latestChapter: '第486话 最终决战',
    updateTime: '2026-08-04',
    tags: ['热血', '魔法', '穿越', '战斗'],
  },
  {
    id: 2,
    title: '斗破苍穹',
    author: '天蚕土豆',
    artist: '任翔',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20a%20young%20warrior%20with%20flame%20surrounding%20his%20body%20holding%20a%20heavy%20ancient%20sword%2C%20dramatic%20fiery%20background%2C%20intense%20expression%2C%20anime%20style%2C%20high%20contrast%20colors%2C%20clean%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    rating: 9.5,
    popularity: 8765432,
    status: '连载中',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人，种种打击接踵而至。就在他即将绝望的时候，一缕灵魂从他手上的戒指里浮现，一扇全新的大门在面前开启！',
    chapters: 421,
    latestChapter: '第421话 炎帝归来',
    updateTime: '2026-08-03',
    tags: ['热血', '玄幻', '修炼', '逆袭'],
  },
  {
    id: 3,
    title: '完美世界',
    author: '辰东',
    artist: '时代漫画',
    category: 'cultivation',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20of%20a%20young%20cultivator%20boy%20with%20ancient%20Chinese%20attire%20standing%20on%20a%20mountain%20peak%20with%20glowing%20energy%20aura%2C%20mythical%20beasts%20in%20the%20distance%2C%20epic%20fantasy%20atmosphere%2C%20vibrant%20anime%20art%20style%2C%20clean%20background&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    rating: 9.4,
    popularity: 7654321,
    status: '连载中',
    description: '一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。问苍茫大地，谁主沉浮？！一个少年从大荒中走出，一切从这里开始……',
    chapters: 358,
    latestChapter: '第358话 大荒纪',
    updateTime: '2026-08-04',
    tags: ['玄幻', '修仙', '热血', '战斗'],
  },
  {
    id: 4,
    title: '元尊',
    author: '天蚕土豆',
    artist: 'Dr.大吉',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20showing%20a%20handsome%20young%20man%20with%20flowing%20black%20hair%20and%20mysterious%20purple%20energy%20surrounding%20him%2C%20wearing%20elegant%20robes%2C%20calm%20but%20determined%20expression%2C%20oriental%20fantasy%20style%2C%20clean%20light%20background&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    rating: 9.3,
    popularity: 6543210,
    status: '连载中',
    description: '这是一个气掌乾坤的世界，一气可搬山，可倒海，可翻天，可掌阴阳乾坤。身为大周王朝太子的周元，天生的 waste 体质让他无法修炼，直到命运让他遇到了一缕神秘的气息……',
    chapters: 312,
    latestChapter: '第312话 源气复苏',
    updateTime: '2026-08-02',
    tags: ['玄幻', '修炼', '热血', '逆袭'],
  },
  {
    id: 5,
    title: '全职高手',
    author: '蝴蝶蓝',
    artist: '常盘勇者',
    category: 'urban',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20of%20a%20cool%20esports%20player%20with%20silver%20hair%20holding%20a%20game%20controller%2C%20futuristic%20gaming%20theme%2C%20competitive%20atmosphere%2C%20dynamic%20e-sports%20vibe%2C%20anime%20art%20style%2C%20clean%20contrast%20background&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    rating: 9.5,
    popularity: 7890123,
    status: '已完结',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐，离开职业圈的他栖身于一家网吧成了一个小小的网管。但是，拥有十年游戏经验的他，在荣耀新开的第十区重新投入了游戏，带着对往昔的回忆和一把未完成的自制武器，开始了重返巅峰之路。',
    chapters: 268,
    latestChapter: '第268话 永远的路（完结）',
    updateTime: '2026-07-15',
    tags: ['电竞', '热血', '竞技', '逆袭'],
  },
  {
    id: 6,
    title: '凡人修仙传',
    author: '忘语',
    artist: 'HeHe',
    category: 'cultivation',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20of%20an%20ordinary-looking%20cultivator%20in%20simple%20gray%20robes%20holding%20a%20magical%20bottle%2C%20standing%20in%20a%20misty%20mountain%20scene%2C%20subtle%20and%20grounded%20atmosphere%2C%20wuxia%20anime%20style%2C%20clean%20soft%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    rating: 9.4,
    popularity: 7234567,
    status: '连载中',
    description: '一个普通的山村穷小子，偶然之下，进入到了一个江湖小门派，成了一名记名弟子。他以这样身份，如何在门派中立足？如何以平庸的资质进入到修仙者的行列？',
    chapters: 524,
    latestChapter: '第524话 灵界风云',
    updateTime: '2026-08-04',
    tags: ['修仙', '凡人流', '慢热', '经典'],
  },
  {
    id: 7,
    title: '星辰变',
    author: '我吃西红柿',
    artist: '初见漫画',
    category: 'cultivation',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20a%20young%20man%20with%20starry%20cosmic%20energy%20flowing%20around%20his%20body%2C%20celestial%20themed%2C%20mysterious%20nebula%20effects%2C%20grand%20cosmic%20scale%2C%20epic%20anime%20illustration%2C%20clean%20dark%20background&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    rating: 9.2,
    popularity: 5987654,
    status: '已完结',
    description: '一名没有修炼资质的少年秦羽，为了得到父亲的重视和关心，毅然选择修炼最痛苦的外功。一枚流星泪，改变了他的一生，揭开了修真界的奥秘。',
    chapters: 396,
    latestChapter: '第396话 鸿蒙金榜（完结）',
    updateTime: '2026-06-20',
    tags: ['修仙', '宇宙', '成长', '经典'],
  },
  {
    id: 8,
    title: '三体',
    author: '刘慈欣',
    artist: '幻创未来',
    category: 'scifi',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20sci-fi%20manhua%20cover%20with%20a%20mysterious%20three-body%20star%20system%20and%20futuristic%20spaceship%2C%20cosmic%20horror%20vibe%2C%20dark%20space%20background%20with%20geometric%20patterns%2C%20philosophical%20atmosphere%2C%20mature%20anime%20style%2C%20clean%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    rating: 9.7,
    popularity: 9123456,
    status: '连载中',
    description: '文化大革命如火如荼进行的同时，军方探寻外星文明的绝秘计划"红岸工程"取得了突破性进展。但在按下发射键的那一刻，历经劫难的叶文洁没有意识到，她彻底改变了人类的命运。',
    chapters: 186,
    latestChapter: '第186话 黑暗森林',
    updateTime: '2026-08-01',
    tags: ['科幻', '宇宙', '文明', '哲学'],
  },
  {
    id: 9,
    title: '斗罗大陆',
    author: '唐家三少',
    artist: '穆逢春',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20of%20a%20young%20boy%20with%20blue%20silver%20grass%20martial%20spirit%20and%20a%20rabbit-eared%20girl%20companion%2C%20fantasy%20martial%20arts%20world%2C%20colorful%20spirit%20rings%2C%20bright%20and%20lively%20anime%20art%2C%20clean%20friendly%20background&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    rating: 9.6,
    popularity: 9876543,
    status: '连载中',
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容。跳崖明志时却来到了另一个世界——斗罗大陆。这里没有魔法，没有斗气，没有武术，却有神奇的武魂。',
    chapters: 542,
    latestChapter: '第542话 海神传承',
    updateTime: '2026-08-03',
    tags: ['玄幻', '热血', '魂环', '成长'],
  },
  {
    id: 10,
    title: '我在精神病院学斩神',
    author: '三九音域',
    artist: '柠檬漫画',
    category: 'urban',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20showing%20a%20mysterious%20young%20man%20with%20one%20golden%20eye%20and%20one%20normal%20eye%20wielding%20a%20glowing%20blade%2C%20supernatural%20urban%20setting%2C%20mysterious%20and%20intense%20mood%2C%20modern%20anime%20style%2C%20clean%20dark%20background&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    rating: 9.3,
    popularity: 6789012,
    status: '连载中',
    description: '都市之中，神明降临。林七夜在一家精神病院里，遇到了一群特殊的病人，他们自称是神明。从此，他的人生轨迹彻底改变，踏上了斩神之路。',
    chapters: 298,
    latestChapter: '第298话 诸神黄昏',
    updateTime: '2026-08-04',
    tags: ['都市', '神明', '热血', '战斗'],
  },
  {
    id: 11,
    title: '一人之下',
    author: '米二',
    artist: '米二',
    category: 'urban',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20of%20a%20mysterious%20girl%20with%20long%20silver%20hair%20and%20a%20hoodie%2C%20urban%20supernatural%20theme%2C%20taoist%20elements%2C%20mysterious%20atmosphere%2C%20distinctive%20Chinese%20art%20style%2C%20clean%20moody%20background&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    rating: 9.5,
    popularity: 8456789,
    status: '连载中',
    description: '随着爷爷尸体被盗，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。急于解开爷爷和自身秘密的张楚岚与没有任何记忆的"不死少女"冯宝宝开启了"异人"之旅。',
    chapters: 456,
    latestChapter: '第456话 甲申之乱',
    updateTime: '2026-08-02',
    tags: ['都市', '异能', '道家', '悬疑'],
  },
  {
    id: 12,
    title: '大奉打更人',
    author: '卖报小郎君',
    artist: '黑鸟社',
    category: 'history',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20of%20a%20detective-like%20character%20in%20ancient%20Chinese%20official%20uniform%20holding%20a%20case%20file%2C%20historical%20fantasy%20setting%2C%20mysterious%20mood%20with%20lantern%20light%2C%20elegant%20oriental%20anime%20art%2C%20clean%20atmospheric%20background&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    rating: 9.4,
    popularity: 7567890,
    status: '连载中',
    description: '这个世界，有儒；有道；有佛；有妖；有术士。警校毕业的许七安幽幽醒来，发现自己身陷囹圄，三天后就要被流放边疆。他起初的目的只是自保，顺便在这个没人权的社会里当个富家翁悠闲度日。',
    chapters: 334,
    latestChapter: '第334话 京城风云',
    updateTime: '2026-08-03',
    tags: ['穿越', '探案', '历史', '修仙'],
  },
];

export const heroBanners = [
  {
    id: 1,
    comicId: 1,
    title: '全职法师 · 魔法世界的巅峰之战',
    subtitle: '全系魔法天才莫凡，踏上巅峰之路',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Chinese%20manhua%20banner%20scene%20featuring%20a%20powerful%20mage%20casting%20multiple%20elemental%20spells%20fire%20ice%20lightning%20and%20shadow%20in%20an%20epic%20fantasy%20cityscape%2C%20cinematic%20composition%2C%20vibrant%20magical%20effects%2C%20dark%20dramatic%20sky%2C%20widescreen%20format&width=1600&height=700&seq=hero-banner-01&orientation=landscape',
    color: 'from-amber-900/60 via-red-900/50 to-orange-900/60',
  },
  {
    id: 2,
    comicId: 9,
    title: '斗罗大陆 · 武魂觉醒',
    subtitle: '唐三的魂师之路，从圣魂村开始',
    image: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Chinese%20manhua%20banner%20scene%20with%20colorful%20spirit%20rings%20glowing%20around%20a%20young%20warrior%20standing%20proudly%2C%20mythical%20forest%20background%2C%20magical%20creatures%2C%20bright%20and%20heroic%20atmosphere%2C%20widescreen%20cinematic%20style&width=1600&height=700&seq=hero-banner-02&orientation=landscape',
    color: 'from-blue-900/60 via-indigo-900/50 to-purple-900/60',
  },
  {
    id: 3,
    comicId: 8,
    title: '三体 · 给岁月以文明',
    subtitle: '宇宙社会学，黑暗森林法则',
    image: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20Chinese%20manhua%20banner%20with%20a%20vast%20cosmic%20scene%20showing%20the%20three-body%20star%20system%20and%20mysterious%20alien%20civilization%2C%20deep%20space%2C%20geometric%20patterns%2C%20philosophical%20dark%20atmosphere%2C%20cinematic%20widescreen&width=1600&height=700&seq=hero-banner-03&orientation=landscape',
    color: 'from-gray-900/70 via-slate-900/60 to-black/70',
  },
];

export const hotRanking = comics.slice(0, 10).sort((a, b) => b.popularity - a.popularity);

export const latestUpdates = [...comics].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime());

export const featuredComic = comics[0];

export const aboutInfo = {
  brandName: '八仔漫画网',
  founded: '2018',
  description: '八仔漫画网成立于2018年，是国内领先的正版漫画在线阅读平台。我们致力于为漫画爱好者提供高品质、正版授权的漫画内容，让每一位读者都能享受纯净、流畅的阅读体验。经过多年的发展，八仔漫画网已拥有上万部正版漫画作品，涵盖玄幻、都市、修仙、科幻、悬疑等多种题材，日活跃用户超过500万。',
  mission: '让好漫画触手可及，打造最纯净的漫画阅读社区。',
  values: ['正版授权', '纯净阅读', '用户至上', '内容为王'],
  stats: [
    { value: '10000+', label: '正版漫画' },
    { value: '500万+', label: '日活用户' },
    { value: '99.9%', label: '好评率' },
    { value: '8年', label: '品牌历史' },
  ],
  reviews: [
    { name: '漫画迷小王', avatar: '', rating: 5, content: '用了三年多了，画质清晰加载快，没有任何广告弹窗，体验真的超级棒！全职法师追了一整年，更新很及时。', date: '2026-07-28' },
    { name: '追更达人', avatar: '', rating: 5, content: '界面简洁大方，分类很清晰，找漫画特别方便。最关键是全免费，不用付费也能看全集，良心平台！', date: '2026-07-25' },
    { name: '书虫小李', avatar: '', rating: 5, content: '漫画资源很全，很多热门作品都有。阅读体验流畅，画质也高，推荐给了很多朋友。客服响应也很快！', date: '2026-07-20' },
    { name: '二次元少女', avatar: '', rating: 4, content: '非常喜欢这个平台的设计风格，很清爽。漫画更新速度也很快，追更体验满分。希望以后能增加更多国漫作品。', date: '2026-07-18' },
    { name: '资深漫迷', avatar: '', rating: 5, content: '从2018年就开始用了，看着平台一步步成长。现在漫画种类越来越丰富，阅读体验也越来越好。强烈推荐！', date: '2026-07-15' },
    { name: '新用户阿杰', avatar: '', rating: 5, content: '朋友推荐的，下载后停不下来。页面很干净，比之前用的其他平台好太多了。全职法师漫画画质超赞！', date: '2026-07-12' },
  ],
  contact: {
    email: 'contact@bazai-comics.com',
    phone: '400-888-6666',
    address: '浙江省杭州市余杭区文一西路969号',
    wechat: '八仔漫画',
    weibo: '@八仔漫画官方',
    qq: '88886666',
  },
};

export const faqList = [
  { question: '八仔漫画网的所有漫画都是免费的吗？', answer: '是的！八仔漫画网上的所有漫画作品均为正版授权内容，用户无需付费即可免费在线阅读全部章节，没有任何隐藏收费。' },
  { question: '全职法师漫画多久更新一次？', answer: '全职法师漫画通常每周更新2-3话，具体更新时间以漫画详情页显示为准。您可以在作品页面收藏漫画，更新后会第一时间收到通知。' },
  { question: '如何在手机上阅读漫画？', answer: '八仔漫画网采用了响应式设计，直接使用手机浏览器访问我们的网站即可获得适配移动端的阅读体验，无需额外下载APP。' },
  { question: '阅读时遇到加载问题怎么办？', answer: '如果遇到漫画加载缓慢，建议检查网络连接或尝试刷新页面。如问题持续存在，可以通过"联系我们"页面反馈，我们会在24小时内处理。' },
  { question: '可以下载漫画离线阅读吗？', answer: '为了保护版权方的权益，目前不支持漫画下载功能。但您可以随时在线流畅阅读所有内容，建议使用WiFi环境下阅读以获得最佳体验。' },
  { question: '如何向平台推荐漫画作品？', answer: '如果您有希望引进的漫画作品，可以通过"联系我们"页面发送邮件推荐，我们的内容团队会定期评估用户的推荐清单。' },
];

export const chapterList = Array.from({ length: 50 }, (_, i) => ({
  id: i + 1,
  title: `第${486 - i}话${i < 10 ? [' 巅峰之战', ' 魔法觉醒', ' 暗影降临', ' 元素共鸣', ' 星辰之力', ' 禁忌之术', ' 命运抉择', ' 最终试炼', ' 世界之巅', ' 永恒之光'][i] : ''}`,
  updateTime: new Date(2026, 7, 4 - Math.floor(i / 3)).toISOString().split('T')[0],
}));